export function initHeroScroll(wrapper: HTMLElement): () => void {
    const contentEl = wrapper.querySelector<HTMLElement>(".hero-scroll__content");
    const overlayEl = wrapper.querySelector<HTMLElement>(".hero-scroll__overlay");

    if (!contentEl || !overlayEl) {
        return () => {};
    }

    let posY = 0;
    let resizeFrame = 0;

    function onScroll(): void {
        const d = posY - window.scrollY;
        const newSticky = d > 0 ? 0 : d * -1;
        
        if (!contentEl) {
            return;
        }

        contentEl.style.transform = `translateY(${newSticky}px)`;

        if (!overlayEl) {
            return;
        }
        
        if (newSticky > 0) {
            overlayEl.style.opacity = ".55";
        } else {
            overlayEl.style.opacity = "0";
        }
    }

    function updatePosition(): void {
        if (posY === 0) {
            // Keep the same "+20" workaround from the React version.
            posY = wrapper.getBoundingClientRect().top + window.scrollY + 20;
        } else {
            posY = wrapper.getBoundingClientRect().top + window.scrollY;
        }

        onScroll();
    }

    function onResize(): void {
        if (resizeFrame !== 0) {
            return;
        }

        resizeFrame = window.requestAnimationFrame(() => {
            resizeFrame = 0;
            updatePosition();
        });
    }

    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, { passive: true });

    onResize();

    return () => {
        window.removeEventListener("resize", onResize);
        window.removeEventListener("scroll", onScroll);

        if (resizeFrame !== 0) {
            window.cancelAnimationFrame(resizeFrame);
        }

        contentEl.style.transform = "translateY(0px)";
        overlayEl.style.opacity = "0";
    };
}
